// 设备共享
export default {
    username: 'User Name',
    remarks: 'Remarks',
    PN: 'Phone Number',
    ASU: 'Add shared user',
    SD: 'Shared devices',
    VD: 'Vip devices',
    DN: 'Device name',
    CV: 'Current vip',
    FS: 'Flight status',
    IF: 'In flight',
    NF: 'Not flying',
    deviceshar: 'Device sharing',
    dev: 'Equipment',
    Shareuser: 'Shared users',
    pinputshareuser: 'Please enter a shared user',
    addsharedev: 'Add shared device',
    owner: 'Owner',
    Exclusiveuser: 'Exclusive users',
    cancelshare: 'Unshare',
    exitshare: 'Exit sharing',
    setexclusive: 'Set up exclusive',
    cancelexclusive: 'Cancel exclusive',
    getexclusive: 'Get exclusive',
    selsharedev: 'Choose a shared device',
    mobile: 'phone',
    flymodel: 'UAV model',
    next: 'next step',
    selectsharduser: 'Select shared users',
    user: 'accounts',
    userno: 'User does not exist or is not registered',
    add: 'add to',
    historyuser: 'History sharing user',
    clearhistory: 'Clear history',
    editsharedev: 'Edit shared device',
    sharenum: 'Number of shares',
    manycancel: 'Batch cancel',
    setexclusiveuser: 'Set up exclusive users',
    pselectdev: 'Please select a device to share first',
    pselectshareuser: 'Please select users to share',
    pselectexcuser: 'Please select the users to be exclusive',
    cancelcdevshare: 'This operation will cancel this device sharing. Do you want to continue',
    cancelchedevshare: 'This operation will uncheck device sharing. Do you want to continue',
    cancelexitshare: 'This operation exits this device sharing. Do you want to continue',
    exited: 'Exit cancelled',
    canceled: 'Cancelled',
    onlysetshareuser: 'Only one exclusive user can be set',
    tip_del: 'After deleting a user, the user will not be able to share and enjoy the device. Do you want to delete it?',
    tip_MODID: 'Meaning of data item: device name (current exclusive user)',
    tip_PEDN: 'Please enter device name',
    tip_MODID1: 'Meaning of data item: device name (current exclusive user), which cannot be checked in flight',
}